var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header header-fix"},[_c('van-nav-bar',{attrs:{"safe-area-inset-top":"","title":this.$route.meta.title},on:{"click-left":_vm.onClickLeft},scopedSlots:_vm._u([(this.$route.meta.iconLeft)?{key:"left",fn:function(){return [_c('van-icon',{staticClass:"font",attrs:{"name":"arrow-left"}})]},proxy:true}:null],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }